<div class="panel_div">
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Filter
    </mat-panel-title>
    <mat-panel-description>
      This is a summary of the content
    </mat-panel-description>
  </mat-expansion-panel-header>




  <form [formGroup]="filterFormGroup">


    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
      <mat-form-field fxFlex>
        <mat-label>{{ 'interface.pickup_date_range' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate formControlName="pickup_start" placeholder="Start date">
          <input matEndDate formControlName="pickup_end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>


      <mat-form-field fxFlex>
        <mat-label>{{ 'interface.delivery_date_range' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="picker2">
          <input matStartDate formControlName="delivery_start" placeholder="Start date">
          <input matEndDate formControlName="delivery_end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-date-range-picker #picker2></mat-date-range-picker>
      </mat-form-field>


    </div>

    <button mat-raised-button color="primary" class="btn-block" (click)="applyFilter()" [disabled]="!filterFormGroup.valid">{{ 'interface.apply' | translate}}</button>
    <button mat-raised-button color="warn" class="btn-block" (click)="resetFilter()">{{ 'interface.reset' | translate}}</button>

  </form>

</mat-expansion-panel>


<mat-horizontal-stepper linear="true" #stepper>
  <mat-step [editable]="true" [stepControl]="facturasFormGroup">
    <!-- <form [formGroup]="facturasFormGroup"> -->
      <ng-template matStepLabel>{{'interface.facturas' | translate}}</ng-template>

<div class="table-responsive">
  <table mat-table [dataSource]="dataSource" class='operations_table'>

    <ng-container matColumnDef="select" >
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row"> <button mat-stroked-button  (click)="rowClick(row, $event)" >{{ 'interface.go' | translate }}</button> </td>
    </ng-container>

    <ng-container matColumnDef="check" >
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row; let i = index">

        <mat-checkbox *ngIf="(row.total_books - row.amount_paid_books) > 0" color="primary"  value="{{row.id}}" (change)="onCheckboxChange(i,row.id,$event)"></mat-checkbox>

      </td>
    </ng-container>





    <ng-container *ngFor="let col of displayedColumns | slice:2" matColumnDef="{{col}}">
        <th mat-header-cell *matHeaderCellDef> {{'interface.' + col | translate}} </th>
        <td mat-cell *matCellDef="let element">
          {{element[col]}}
        </td>
      </ng-container>

    <!-- <ng-container matColumnDef="pickups">
      <th mat-header-cell *matHeaderCellDef> Pickups </th>
      <td mat-cell *matCellDef="let element">
        <mat-list role="list" *ngFor="let pickup of element.pickups">
          {{pickup.site_name}}<br/> {{pickup.city_name}},{{pickup.state}}
        </mat-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="pickups_dates">
      <th mat-header-cell *matHeaderCellDef> Pickups Dates </th>
      <td mat-cell *matCellDef="let element">
        <mat-list role="list" *ngFor="let pickup of element.pickups">
          {{pickup.departure_date}}
        </mat-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="deliveries">
      <th mat-header-cell *matHeaderCellDef> Deliveries </th>
      <td mat-cell *matCellDef="let element">
        <mat-list role="list" *ngFor="let delivery of element.deliveries">
          {{delivery.site_name}}<br/> {{delivery.city_name}},{{delivery.state}}
        </mat-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="deliveries_dates">
      <th mat-header-cell *matHeaderCellDef> Pickups Dates </th>
      <td mat-cell *matCellDef="let element">
        <mat-list role="list" *ngFor="let delivery of element.deliveries">
          {{delivery.departure_date}}
        </mat-list>
      </td>
    </ng-container> -->


    <tr mat-header-row *matHeaderRowDef="displayedColumns"  #stickyH2 ></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>

<button mat-raised-button matStepperNext color="primary">{{'interface.next' | translate}}</button>
<!-- </form> -->
  </mat-step>
  <mat-step [editable]="true">
    <ng-template matStepLabel>{{'interface.journal' | translate}}</ng-template>

    <div class="table-responsive">
      <table mat-table #tableSelected [dataSource]="dataSourceSelected" class='operations_table'>


        <ng-container *ngFor="let col of displayedColumnsSelected" matColumnDef="{{col}}">
            <th mat-header-cell *matHeaderCellDef> {{'interface.' + col | translate}} </th>
            <td mat-cell *matCellDef="let element">
              {{element[col]}}
            </td>
            <td mat-footer-cell *matFooterCellDef> {{totalCol(col)}} </td>
          </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsSelected"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsSelected;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumnsSelected"></tr>


      </table>
    </div>

    <form [formGroup]="formEntry" (submit)="recordPayment()">
      <div fxLayout="column">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
      <mat-form-field fxFlex>
        <input type="text" placeholder="{{ 'interface.account' | translate }}" matInput  [matAutocomplete]="auto" formControlName="account">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngFor="let option of accountFilteredOptions | async" [value]="option">
            {{option.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field fxFlex>
        <input type="text" placeholder="{{ 'interface.total' | translate }}" matInput formControlName="total" >
        <!-- value="{{totalFacturas()}}" -->
      </mat-form-field>

      <mat-form-field fxFlex>
        <mat-label >{{ 'interface.currency' | translate }}</mat-label>
        <mat-select formControlName="currency_id" (selectionChange)="updateCurrency()">
          <mat-option *ngFor="let currency of getCurrencies()" [value]="currency.value">
            {{currency.viewValue | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex>
        <input type="text" placeholder="{{ 'interface.payment_number' | translate }}" matInput formControlName="payment_number" >
      </mat-form-field>

      <mat-form-field fxFlex>
        <input type="text" placeholder="{{ 'interface.total' | translate }}" matInput formControlName="total_books">
        <!-- value="{{totalBooks()}}" -->
      </mat-form-field>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
      <mat-form-field  fxFlex>
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker3" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
        <mat-datepicker #picker3></mat-datepicker>
      </mat-form-field>


      <mat-form-field fxFlex>
       <ngx-mat-file-input formControlName="file"  accept="true" color="primary">
       </ngx-mat-file-input>
     </mat-form-field>


    </div>
    </div>
<!-- [disabled]="!formEntry.valid" -->
    <button mat-stroked-button class="btn-block" type="submit" >{{ 'interface.record_payment' | translate}}</button>


    </form>

  </mat-step>
</mat-horizontal-stepper>
</div>
